<div *ngIf="news">
  <h1 class="mb-4 title">{{news.title}}</h1>
  <div class="columns">
    <div *ngIf="news.images && news.images.length > 0" class="column is-one-quarter">
      <img *ngFor="let image of news.images" alt="{{news.title}}" src="{{resourceUrl}}{{image.thumbnails.medium}}" class="image">
    </div>
    <div class="column" >
      <div [innerHTML]="safeHTML(news.text ?? '')"></div>
      <div *ngIf="news.files && news.files.length > 0" class="mt-4">
        <a *ngFor="let file of news.files; let i = index" href="{{resourceUrl}}{{file.filePath}}" class="is-block m-2 is-size-3 is-underlined" target="_blank">Download <span *ngIf="i!=0">{{i}}</span></a>
      </div>
    </div>
  </div>
</div>

